<div
  *ngIf="errorMessage && (control.touched || control.dirty)"
  class="input-field-error"
>
  {{ errorMessage }}
</div>
